import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { Field, reduxForm } from 'redux-form';
import FormTextField from '../../legacyForm/FormTextField';
import { accountActivationFormValidation } from '../../../models/auth/AuthModelValidation';
import './PasswordResetFormStyles.scss';

let PasswordResetForm = ({ handleSubmit, submitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      <div>
        <Field 
          name="newPassword" 
          type="password" 
          component={FormTextField}
          label="Utwórz hasło - co najmniej 8 znaków, w tym jedną cyfrę, wielką literę oraz znak specjalny"
          fullWidth
        />
      </div>
      <Button variant="contained" color="primary" type="submit" className="full-width confirm-button" disabled={submitting}>
        Zapisz
      </Button>
    </form>
  );
};

PasswordResetForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

PasswordResetForm = reduxForm({
  form: 'passwordResetForm',
  validate: accountActivationFormValidation,
})(PasswordResetForm);

export default PasswordResetForm;


// WEBPACK FOOTER //
// ./src/components/auth/passwordReset/PasswordResetForm.js